var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 26C8.6075 26 3 31.6075 3 38.5C3 45.3925 8.6075 51 15.5 51C22.3925 51 28 45.3925 28 38.5C28 31.6075 22.3925 26 15.5 26ZM21.0191 36.982L14.5376 43.4635C14.2665 43.7347 13.911 43.8704 13.5556 43.8704C13.2001 43.8704 12.8446 43.7347 12.5735 43.4635L9.79574 40.6857C9.25333 40.1434 9.25333 39.264 9.79574 38.7216C10.3381 38.1793 11.2175 38.1793 11.7599 38.7216L13.5556 40.5173L19.055 35.0179C19.5973 34.4756 20.4768 34.4756 21.0192 35.0179C21.5615 35.5603 21.5615 36.4397 21.0191 36.982Z",
    fill: "#375DFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 15.3125C39.4734 15.3125 38.8438 14.6829 38.8438 13.9062V3.125H18.6875C16.3613 3.125 14.4688 5.01753 14.4688 7.34375V23.0646C14.9321 23.0226 15.4009 23 15.875 23C20.6683 23 24.9591 25.1915 27.7987 28.625H43.0625C43.8391 28.625 44.4688 29.2546 44.4688 30.0312C44.4688 30.8079 43.8391 31.4375 43.0625 31.4375H29.6514C30.5304 33.1528 31.0972 35.053 31.2792 37.0625H43.0625C43.8391 37.0625 44.4688 37.6921 44.4688 38.4688C44.4688 39.2454 43.8391 39.875 43.0625 39.875H31.2792C30.8586 44.5193 28.3772 48.5774 24.7586 51.125H46.8125C49.1387 51.125 51.0312 49.2325 51.0312 46.9062V15.3125H40.25ZM43.0625 23H22.4375C21.6609 23 21.0312 22.3704 21.0312 21.5938C21.0312 20.8171 21.6609 20.1875 22.4375 20.1875H43.0625C43.8391 20.1875 44.4688 20.8171 44.4688 21.5938C44.4688 22.3704 43.8391 23 43.0625 23Z",
    fill: "#2342BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6562 3.94824V12.4998H50.2073L41.6562 3.94824Z",
    fill: "#2342BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.0080fbd17d2777297767b57e5afff675.svg";
export { ForwardRef as ReactComponent };